module.exports = __webpack_public_path__ + "img/32557ed.png";